/**
 * Created by sshu on 2025/12/12
 */
import * as API from '@/service/index'

//获取学校统计
export const getSchoolStatistic = (params) => {
    return API.GET('/stats/learningMachine/getSchoolStatistic', params)
}
//获取应用使用top10
export const getAppUseTop = (params) => {
    return API.GET('/stats/learningMachine/getAppUseTop', params)
}
//获取应用近七天使用趋势
export const getAppUseTrend = (params) => {
    return API.GET('/stats/learningMachine/getAppUseTrend', params)
}
//获取应用类型分布
export const getAppUseDistribution = (params) => {
    return API.GET('/stats/learningMachine/getAppUseDistribution', params)
}
//获取应用使用明细
export const getAppUseDetail = (params) => {
    return API.GET('/stats/learningMachine/getAppUseDetail', params)
}
//获取应用使用明细
export const getClassUseList = (params) => {
    return API.GET('/stats/learningMachine/getClassUseList', params)
}